(function() {
  const messageModule = $('.animateMessageModule');
  const videoNumber = $('.animateMessageModule img');

  $.jScrollability([
    {
      'selector': messageModule,
      'start': function($el) { return $el.offset().top + window.innerHeight },
      'end': function($el) { return $el.offset().top + $el.height() },
      'fn': function($el, pcnt) {
        videoNumber.css({
          'right': `${((pcnt * 1.5) - 0.95) * 100}%`,
        });
      }
    }
  ]);
}());
